module.exports = __webpack_public_path__ + "media/images/icons/material/certificate-dda481bf99a18e7da0790b41ef0c9ed1.svg";